var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealifeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1352.073,
    height: 363.038,
    viewBox: "0 0 1352.073 363.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 1352.073,
    height: 363.038,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M723.559,0l-5.73,21.438L645.807,294.833l-.007.038.054-.015,111.292-24.619L777,195l-26.153.906L789.811,47.794l.1-.352,2.033-7.733,2.6-9.866Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M1156.242,181.945l-294.512,65.2L876.4,191.585l19.616-.68Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M163.6,2.485l-9.49,53.555H63.949L73.666,2.485H26.89L0,153.658H47l10.168-58.3h90.162l-10.395,58.3h46.55L210.377,2.485Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M394.761,114.792,357.7,153.659H212.178L239.069,2.486h174.9L376.684,41.8H278.839l-3.164,18.078H395.213l-32.54,34.347h-93.1l-3.615,20.563Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M460.061,153.658l35.251-38.867h37.737c9.264,0,19.659,0,26.89.452-3.164-5.423-7.909-14.688-11.524-21.919l-20.112-40-88.579,100.33H384.361L505.481,16.947C513.389,8.134,524.01,0,538.7,0c14.01,0,21.919,7.456,26.89,16.947l70.276,136.711Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M935.849,153.658H889.073L915.963,2.485h46.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1161.135,2.486,1124.076,41.8h-92.421l-3.39,19.658h113.888l-34.8,36.833h-85.642L1012,153.659h-47L991.884,2.486Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M1332.866,114.792l-37.059,38.867H1150.283l26.89-151.173h174.9L1314.788,41.8h-97.844l-3.164,18.078h119.538l-32.54,34.347h-93.1l-3.615,20.563Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M851.871,284.512h-.007l-26.723,8.162,52.8-206.548h-.008l-18.357-6.473-.1-.024-23.525-8.295-.024.077L833.084,82.17,804.939,189.052l-.016.047-1.306,4.934v.008l-2.337,8.889-16.051,60.935-.008.046h-.008l-2.486,9.444-.094.016-15.261,57.848-.727,2.8-2.486,9.576-5.183,19.444.641-.274,7.576-28.7.031-.007.015-.008-2.486,9.577-5.1,19.123,38.95-16.754,12.095-5.2.008-.008,29.67-12.759.008-.008,56.15-24.151,264.6-113.825Zm-46.338-95.436-.016.055-1.305,4.933v.008l-2.338,8.881L785.823,263.9l-.007.039-.008.007-2.487,9.444-.093.017-15.261,57.846,1.289-4.972.079-.312.352-1.354,1.321-5.121.023.009,11.751-44.493.422-1.6,2.494-9.451h.008l.008-.048,18.435-69.839,29.53-111.879Z",
    fill: "#b6e701"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealifeLogo);
export default __webpack_public_path__ + "static/media/healife-logo.0c376927214ea55c9aa8a76a45e5a891.svg";
export { ForwardRef as ReactComponent };